/**
 * Call Module - Main barrel export
 * 
 * Modular architecture for the OperationsCallModal system
 * Supports: Web, Capacitor (iOS/Android), Tauri (Desktop)
 * 
 * Usage:
 * ```tsx
 * import { 
 *   // Types
 *   CallState, CallType, CallParticipant,
 *   
 *   // Hooks
 *   useCallSession, useCallControls, useCallNotifications,
 *   
 *   // UI Components
 *   RingingUI, InCallUI, ContactsView, RecentsView, DialPadView,
 *   
 *   // Shared Components
 *   CallAvatar, CallTimer, ParticipantGrid
 * } from '@/components/call';
 * ```
 */

// ============================================
// Types
// ============================================
export * from './types';

// ============================================
// Hooks
// ============================================
export { useCallSession } from './hooks/useCallSession';
export { useCallControls } from './hooks/useCallControls';
export { useCallNotifications } from './hooks/useCallNotifications';
export { useCallPlugins } from './hooks/useCallPlugins';

// ============================================
// Shared Components
// ============================================
export { CallAvatar } from './shared/CallAvatar';
export { CallTimer } from './shared/CallTimer';
export { ParticipantGrid, ParticipantCard, ParticipantList } from './shared/ParticipantGrid';

// ============================================
// UI View Components
// ============================================
export { RingingUI } from './ui/RingingUI';
export { InCallUI } from './ui/InCallUI';
export { ContactsView } from './ui/ContactsView';
export { RecentsView } from './ui/RecentsView';
export { DialPadView } from './ui/DialPadView';
export { CrmDialContactsList } from './ui/CrmDialContactsList';
export { fetchCrmContactsForDialer } from './fetchCrmContactsForDialer';
